import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import './ContactUs.css';
import { DASHBOARD, KING_PRICE_NAM_GOOGLE_MAPS, KING_PRICE_SA_GOOGLE_MAPS} from '../../routes/routes'
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { SA_LAT, SA_LONG, NAM_LAT, NAM_LONG, NAM_CLAIMS_EMAIL, SA_CLAIMS_EMAIL, NAM_TEL, SA_TEL, NAM_ADDRESS1, NAM_ADDRESS2, NAM_ADDRESS3, NAM_ADDRESS4, SA_ADDRESS1, SA_ADDRESS2, SA_ADDRESS3, SA_ADDRESS4, NAM_SALES_EMAIL, SA_SALES_EMAIL, NAM_CLIENT_CARE_EMAIL, SA_CLIENT_CARE_EMAIL, NAM_COUNTRY_ID_NUMBER } from "../../constants/internationalization";
import ContactUsWhatsAppBlock from './ContactUsWhatsAppBlock';

class ContactUS extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            lat: SA_LAT,
            lng: SA_LONG
        };
    }

    componentDidMount() {
        if (this.props.profile.countryId === 157) {
            this.setState({
                lat: NAM_LAT,
                lng: NAM_LONG
            });
        } else {
            this.setState({
                lat: SA_LAT,
                lng: SA_LONG
            });
        }
    }

    render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]

        let googleMapsUrl = KING_PRICE_SA_GOOGLE_MAPS;

        if (this.props.profile.countryId === 157) {
            googleMapsUrl = KING_PRICE_NAM_GOOGLE_MAPS;
        }

        return (
            <div id="ContactUs" className="container-fluid new-page-margins">
                <div className="new-breadcrumbwrapper breadcrumb-wrapper-contact-us">
                    <KPBreadCrumb navList={BreadcrumbDetails} activePage="Contact us" />
                </div>
                {/*/// ROW 1 ///*/}
                <div className="row align-content-stretch new-page-main-row">
                    <div className="col nopa contact-us-left-col nomaxwidth">
                        <div className="ContactUsBlock">
                            <h2>Contact us</h2>
                            <p>
                                Need some help? Get in touch with our&nbsp;
                                <br className="contactus-br mobile-br"/>
                                team. We're eager to assist.
                            </p>
                        </div>
                    </div>
                    {this.props.profile.countryId !== 157 &&
                        <div className="col nopa contact-us-right-col">
                            <div className="contact-us-whatsapp-desktop">
                                <ContactUsWhatsAppBlock />
                            </div>
                        </div>
                    }
                    <div className="col nopa contact-us-space-col"></div>
                </div>
                {/*/// ROW 2 ///*/}
                <div className="row align-content-stretch new-page-main-row">
                    <div className="col nopa contact-us-left-col nomaxwidth">
                        <div className="address">
                            <span className="where-to-find-us">Where to find us</span>
                            <div id="mapsContainer" className="google">
                                <div style={{ height: '100%', width: '100%' }}>
                                    <a rel="noopener noreferrer" onClick={() => window.open(googleMapsUrl, "_blank")} >
                                        <Map google={this.props.google}
                                            center={{ lat: this.state.lat, lng: this.state.lng }}
                                            containerStyle={{
                                                position: 'relative',
                                                overflow: 'hidden',
                                                width: '100%',
                                                height: '294px',
                                            }}>
                                            <Marker
                                                // @ts-ignore
                                                position={{ lat: this.state.lat, lng: this.state.lng }}
                                                draggable={false}
                                                title="King Price Insurance"
                                            />
                                        </Map>
                                    </a>
                                </div>
                            </div>
                            <div className="pl-20px pb-21px mt-16px contact-head-office-block">
                                <div className="row noma">
                                    <div className="col nopa contact-head-office-col">
                                        <p>Head office</p>
                                        <p>{this.props.profile.countryId === 157 ? NAM_ADDRESS1 : SA_ADDRESS1}</p>
                                        <p>{this.props.profile.countryId === 157 ? NAM_ADDRESS2 : SA_ADDRESS2}</p>
                                        <p>{this.props.profile.countryId === 157 ? NAM_ADDRESS3 : SA_ADDRESS3}</p>
                                        <p>{this.props.profile.countryId === 157 ? NAM_ADDRESS4 : SA_ADDRESS4}</p>
                                    </div>
                                    <div className="col nopa pr-10px">
                                        <p>Business hours</p>
                                        <p>
                                            Mondays to Fridays
                                        </p>
                                        <p>
                                            08:00 - {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? '18:00' : '16:30'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.profile.countryId !== 157 &&
                            <div className="contact-us-whatsapp-mobile">
                                <ContactUsWhatsAppBlock />
                            </div>
                        }
                    </div>
                    <div className="col nopa contact-us-right-col contact-us-container">
                        <div className="col-12 content-box-padding-20px">
                            <label>Claims</label>
                            <a href={this.props.profile.countryId === 157 ? "mailto:" + NAM_CLAIMS_EMAIL : "mailto:" + SA_CLAIMS_EMAIL} target="_blank">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <Image src="./images/ContactUs/email.svg" alt="Email us" title="Email us" />
                                    </div>
                                    <input type="text" className="form-control" disabled value={this.props.profile.countryId === 157 ? NAM_CLAIMS_EMAIL : SA_CLAIMS_EMAIL} />
                                </div>
                            </a>
                            <a href={this.props.profile.countryId === 157 ? "tel:" + NAM_TEL : "tel:" + SA_TEL} target="_blank">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <Image src="./images/ContactUs/phone.svg" title="Call us" alt="Call us" />
                                    </div>
                                    <input type="text" className="form-control" disabled value={this.props.profile.countryId === 157 ? NAM_TEL : SA_TEL} />
                                </div>
                            </a>
                        </div>
                        <div className="col-12 content-box-padding-20px">
                            <label>Client care</label>
                            <a href={this.props.profile.countryId === 157 ? "mailto:" + NAM_CLIENT_CARE_EMAIL : "mailto:" + SA_CLIENT_CARE_EMAIL} target="_blank">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <Image src="./images/ContactUs/email.svg" alt="Email us" title="Email us" />
                                    </div>
                                    <input type="text" className="form-control" disabled value={this.props.profile.countryId === 157 ? NAM_CLIENT_CARE_EMAIL : SA_CLIENT_CARE_EMAIL} />
                                </div>
                            </a>
                            <a href={this.props.profile.countryId === 157 ? "tel:" + NAM_TEL : "tel:" + SA_TEL} target="_blank">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <Image src="./images/ContactUs/phone.svg" title="Call us" alt="Call us" />
                                    </div>
                                    <input type="text" className="form-control" disabled value={this.props.profile.countryId === 157 ? NAM_TEL : SA_TEL} />
                                </div>
                            </a>
                        </div>
                        <div className="col-12 content-box-padding-20px">
                            <label>Sales</label>
                            <a href={this.props.profile.countryId === 157 ? "mailto:" + NAM_SALES_EMAIL : "mailto:" + SA_SALES_EMAIL} target="_blank">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <Image src="./images/ContactUs/email.svg" alt="Email us" title="Email us" />
                                    </div>
                                    <input type="text" className="form-control" disabled value={this.props.profile.countryId === 157 ? NAM_SALES_EMAIL : SA_SALES_EMAIL} />
                                </div>
                            </a>
                            <a href={this.props.profile.countryId === 157 ? "tel:" + NAM_TEL : "tel:" + SA_TEL} target="_blank">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <Image src="./images/ContactUs/phone.svg" title="Call us" alt="Call us" />
                                    </div>
                                    <input type="text" className="form-control" disabled value={this.props.profile.countryId === 157 ? NAM_TEL : SA_TEL} />
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col nopa contact-us-space-col"></div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(ContactUS);

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);